module.exports = __webpack_public_path__ + "static/media/rato.b44c7396.png";